import React, { useMemo, useState } from "react";
import { Entity } from "@common/types/entity";
import { AccountingTabContext } from "./useAccountingTab";
import { AccountingReportFilters } from "./types";

interface Props {
    initialFilters: AccountingReportFilters;
    selectedEntity?: Entity;
    children: React.ReactNode;
}

/** Accounting tab context with its own filters, for reports shown in drawers. */
export const LocalAccountingTabProvider: React.FC<Props> = ({
    initialFilters,
    selectedEntity,
    children,
}) => {
    const [filters, setFilters] =
        useState<AccountingReportFilters>(initialFilters);
    const contextValue = useMemo(
        () => ({
            filters,
            setFilters,
            selectedEntity,
            ledgerBasis: undefined,
            setLedgerBasis: () => undefined,
        }),
        [filters, selectedEntity],
    );

    return (
        <AccountingTabContext.Provider value={contextValue}>
            {children}
        </AccountingTabContext.Provider>
    );
};
